import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as AddIconSvg } from '../../../assets/icons/add-icon.svg';

export default function AddIcon() {
  return <SvgIcon component={AddIconSvg} sx={{ '& path': { fill: 'white' } }} />;
}
